module.exports = __webpack_public_path__ + "static/media/delete.98894b6a.svg";